import { _js } from '@ifixit/localize';
import * as React from 'react';
import { Quote } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const BlockquoteButton = props => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleBlockquote().run()}
         isActive={editor.isActive('blockquote')}
         isDisabled={!editor.can().toggleBlockquote()}
         icon={<Quote />}
         title={_js('Insert a quote')}
         shortcut={'shift+b'}
      />
   );
};
